import type { Temporal } from '@js-temporal/polyfill'

export type Goal =
  | 'Engagement'
  | 'Connection'
  | 'Reflection'
  | 'Expertise'
  | 'Promotion'
  | 'Education'
  | 'Celebration'

export type Structure = 'Single Text' | 'Threaded'

export type UserType = 'Business' | 'Individual'

export type Type =
  | 'Tip'
  | 'Case Study'
  | 'Story'
  | 'How-to'
  | 'Question'
  | 'Behind the Scenes'
  | 'Opinion'
  | 'List'

export type Tag = 'New' | 'Featured'

export type Template = {
  id: string
  body: string
  emoji: string
  userTypes: UserType[]
  structure: Structure
  goal: Goal
  description: string
  type: Type
  title: string
  tags: Tag[]
  createdAt: string
  color: string
  linkedCampaigns: string[]
  featured: boolean
}

export const USER_TYPES: UserType[] = ['Business', 'Individual']
export const STRUCTURES: Structure[] = ['Single Text', 'Threaded']
export const GOALS: Goal[] = [
  'Engagement',
  'Connection',
  'Reflection',
  'Expertise',
  'Promotion',
  'Education',
  'Celebration',
]

export const TYPES: Type[] = [
  'Tip',
  'Case Study',
  'Story',
  'How-to',
  'Question',
  'Opinion',
  'List',
  'Behind the Scenes',
]

export type CampaignStatus = 'Draft' | 'Active' | 'Archived'

export type BannerColor = 'blue' | 'green' | 'purple' | 'red' | 'yellow'

export type CampaignType = 'Collection' | 'Drip Campaign' | 'Creator Camp'

export interface TemplateCampaign {
  id: string
  name: string
  title?: string
  heading: string
  description?: string
  status: CampaignStatus
  campaignType: CampaignType
  illustration?: string
  bannerColor?: BannerColor
  startDate: Temporal.ZonedDateTime
  endDate: Temporal.ZonedDateTime
  currentDayNumber?: number
  toggleTip?: {
    description: string
    link: string
  }
  showTemplatesAfterEndDate: boolean
  supportsBanner?: boolean
  templateIds: string[]
}
